import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Upload, Download, FileSpreadsheet } from 'lucide-react';

export default function Import() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-stone-900">Data Import</h1>
          <p className="text-stone-600 mt-1">
            Import tasks and data from CSV files
          </p>
        </div>
        <Button variant="outline">
          <Download className="w-4 h-4 mr-2" />
          Download Template
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardContent className="p-6">
            <div className="text-center">
              <Upload className="mx-auto h-12 w-12 text-blue-500 mb-4" />
              <h3 className="text-lg font-medium text-stone-900 mb-2">
                Import Tasks
              </h3>
              <p className="text-stone-600 mb-4">
                Upload a CSV file to bulk import tasks into the system
              </p>
              <Button className="w-full" disabled>
                <FileSpreadsheet className="w-4 h-4 mr-2" />
                Choose CSV File
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6">
            <div className="text-center">
              <Download className="mx-auto h-12 w-12 text-green-500 mb-4" />
              <h3 className="text-lg font-medium text-stone-900 mb-2">
                Export Data
              </h3>
              <p className="text-stone-600 mb-4">
                Download current tasks and data in various formats
              </p>
              <Button variant="outline" className="w-full" disabled>
                <Download className="w-4 h-4 mr-2" />
                Export to CSV
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardContent className="p-6">
          <div className="text-center py-8">
            <FileSpreadsheet className="mx-auto h-12 w-12 text-stone-300 mb-4" />
            <h3 className="text-lg font-medium text-stone-900 mb-2">
              Import/Export Coming Soon
            </h3>
            <p className="text-stone-600 max-w-md mx-auto">
              The data import and export functionality with SheetJS integration
              is being developed. You'll be able to upload CSV files and export
              data in multiple formats.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
